/* Copyright 2013 - 2024 Waiterio LLC */

export const blogId = 'f4dd348fa8f16d3c95941c50'
export const organizationId = 'c398463407b5c12f27f9aed4'
export const blog = 'waiterio'

export default {
  blogId,
  organizationId,
  blog,
}
